/* eslint no-console:0 */

// This file is automatically compiled by Webpack, along with any other files present in this directory. You're encouraged to place your actual application logic in a relevant structure within app/webpacker_assets and only use these pack files to reference that code so it'll be compiled.

// This tells webpacker to build our public css.
// - In development we have set webpacker to build CSS as a javascript file ("inline: true") to be able to do live reloading ("hmr: true") of css without reloading the page. The generated script does not become part of "public.js" because it needs to be included where the stylesheet_pack_tag is in the page.
// - In production we have set webpacker to generate a stand alone .css file.
require('src/public.scss')

// Once we move the code that uses js-cookie into Webpacker, we should no longer need to make this globally available.
window.Cookies = require('js-cookie')

require('turbolinks').start()

window.React = require('react')
window.React.createClass = require('create-react-class')
window.ReactDOM = require('react-dom')
window.ReactRailsUJS = require('react_ujs')
window.Swiper = require('swiper')
